import ChangeSignInBySoftTokenComponent from './ChangeSignInBySoftTokenContainer';

export  default ChangeSignInBySoftTokenComponent ;